<template>
  <v-dialog
    v-model="tagDialog"
    width="350px">
    <div class="dialog-container">
      <h3>{{ isEditTag? 'Edit': 'Create' }} Tag</h3>
      <el-form
        ref='form'
        :model="formData"
        :rules="rules">
        <el-form-item
          prop="name_en_us"
          class="form-item">
          <span>Name (English)</span>
          <v-input v-model="formData.name_en_us" />
        </el-form-item>
        <el-form-item
          prop="name_zh_hk"
          class="form-item">

          <span>Name (Chinese)</span>
          <v-input v-model="formData.name_zh_hk" />
        </el-form-item>
      </el-form>
      <div class="flex-sb">
        <div>
          <v-button @click="handlerCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerCreate">Comfirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { changeTag } from '@/api/news'
export default {
  name: 'TagDialog',
  props:{
    tagId:{
      type: [String, Number],
      default: -1,
    },
    form:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tagDialog: false,
      formData: {
        name_en_us: '',
        name_zh_hk: '',
        tag_id: null
      },
      rules:{
        'name_en_us':[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'name_zh_hk':[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ]
      },
    }
  },
  computed: {
    isEditTag() {
      if(this.tagId == -1){
        this.resetForm()
      }
      return this.tagId != -1
    },
  },
  watch:{
    form:{
      immediate: true,
      handler(val){
        this.formData.name_en_us = '',
        this.formData.name_zh_hk = '',
        this.formData.tag_id =  null
        this.$nextTick(() => {
          Object.assign(this.formData, val)
        })
      }
    }
  },
  methods: {
    changeDialog(){
      this.tagDialog = true
      this.resetForm()
    },

    resetForm(){
      this.$refs['form'] && this.$refs['form'].resetFields()
    },

    handlerCancel() {
      this.tagDialog = false
    },

    handlerCreate() {
      this.$refs['form'].validate(val => {
        if(val){
          if(this.isEditTag) {
            this.network().changeTag('patch',this.formData)
          }
          else {
            this.network().changeTag('post',this.formData)
          } 
        }
      })
    },

    network(){
      return {
        changeTag: async (method, params) => {
          const { data } = await changeTag(method, params)
          if(data.message == 'success'){
            this.tagDialog = false
            if(method != 'put'){
              this.$message({
                type: 'success',
                message: 'Success'
              })
              this.resetForm()
            }
            this.$emit('success')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container {
  padding: 15px;
}
</style>
